var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadgeError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8 6a4.8 4.8 0 11-9.6 0 4.8 4.8 0 019.6 0zM6.6 8.4a.6.6 0 11-1.2 0 .6.6 0 011.2 0zM6 3a.6.6 0 00-.6.6V6a.6.6 0 001.2 0V3.6A.6.6 0 006 3z",
    fill: "currentColor"
  })));
}
export default SvgBadgeError;